<script setup lang="ts">
import StaticPage from "~/components/StaticPage.vue";

const { t } = useI18n();

definePageMeta({
  layout: 'default-light',
})

useSeoMeta({
  title: t('b2b.footer.menu.0'),
})
</script>

<template>
  <StaticPage slug="b2b-agreement" />
</template>

<style scoped>

</style>